<div class="flex-auto">
  <label *ngIf="showLabel && label" class="block font-semibold mb-2">
    <span class="mr-1">{{ label }}</span>
    <span *ngIf="checkRequire" class="text-danger">*</span>
  </label>
  <p-inputNumber
    [fluid]="true"
    (onBlur)="onTouched(); inputBlur()"
    (onInput)="onInput($event)"
    [formControl]="control"
    [maxFractionDigits]="maxFractionDigits"
    [minFractionDigits]="minFractionDigits"
    [ngClass]="{ 'ng-invalid ng-dirty': errors, readonly: readonly }"
    [prefix]="prefix"
    [readonly]="readonly"
    [suffix]="suffix"
    [useGrouping]="useGrouping"
    [maxlength]="maxLength"
    [placeholder]="placeholder"
    [max]="max"
    [min]="min"
    locale="en-US"
  ></p-inputNumber>
  <div *ngIf="errors" class="validator-errors">
    <small class="error-msg block fadeinup animation-duration-300">
      <span class="block text-danger">{{ getError().key | translate: getError().required }}</span>
    </small>
  </div>
</div>
